class TabsWithMedia {
  constructor() {
    this.tabsClass = '.tabs-with-media__tabs';
    this.tabsItemClass = `${this.tabsClass} button`;
    this.tabsTitleClass = `${this.tabsClass} span`;
  }

  onClick = (tab) => {
    tab.addEventListener('click', (e) => {
      if (e.target.getAttribute('aria-selected') === 'true') {
        return false;
      }

      const parent = e.target.closest(this.tabsClass);
      e.target.setAttribute('aria-selected', 'true');
      e.target.removeAttribute('tabIndex');

      parent.querySelectorAll('button').forEach((tabItem) => {
        if (tabItem.id !== e.target.id) {
          tabItem.setAttribute('aria-selected', 'false');
        }
      });
      return false;
    });
  };

  events = () => {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll(this.tabsItemClass).forEach((tab) => {
        this.onClick(tab);
      });

      document.querySelectorAll(this.tabsTitleClass).forEach((tabTitle) => {
        tabTitle.addEventListener('click', (e) => {
          e.stopPropagation();

          const button = e.target.closest('button');

          if (button) {
            button.click();
          }

          return false;
        });
      });
    });
  };
}

const TabsWithMediaObject = new TabsWithMedia();
TabsWithMediaObject.events();
